// Cached accessors for rarely-changing, widely-read data.
// Thin wrappers around cachedGet + the existing API layer so callers don't repeat
// the key/TTL/normalization logic. See cachedGet.js for the caching strategy.

import API, { gymAPI } from './api';
import { cachedGet, invalidateCachedGet } from './cachedGet';

/**
 * Returns the normalized gym object for a gymId (the same shape callers already
 * used via `response.data.data || response.data`). Cached ~5 min.
 */
export const getCachedGym = (gymId) =>
  cachedGet(`gym:${gymId}`, async () => {
    const res = await gymAPI.getGymById(gymId);
    return res.data?.data || res.data;
  });

/**
 * Returns the raw `/permissions/my-gym` response body (e.g.
 * `{ success, allowedMenus }`). The endpoint is derived from the auth token, so a
 * single stable key is used — the Sidebar and the member dashboard share one
 * cache entry. The cache is cleared on login/logout (see authSlice) to avoid any
 * cross-user staleness within the same tab. Cached ~5 min.
 */
export const getCachedMyGymPermissions = () =>
  cachedGet('permissions:my-gym', async () => {
    const res = await API.get('/permissions/my-gym');
    return res.data;
  });

/** Clear cached gym/permissions (e.g. on logout or after a settings change). */
export const clearCachedGym = (gymId) => invalidateCachedGet(gymId ? `gym:${gymId}` : undefined);
export const clearCachedData = () => invalidateCachedGet();
